var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
var InitialTitle = function (_a) {
    var nativeLeftTitleRef = _a.nativeLeftTitleRef, mainTitleText = _a.mainTitleText, textTitleColorClass = _a.textTitleColorClass;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.jobs__title__initial',
                start: 'top center',
            },
        });
        tl.fromTo('.jobs__title__initial--text', {
            opacity: 0,
            duration: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
        });
    }, []);
    return (_jsx("span", __assign({ className: "jobs__title__initial h-full w-full items-start justify-center flex mt-10" }, { children: _jsx("p", __assign({ className: "z-50 mb-10 lg:w-11/12 break-words text-left  font-normal leading-tight md:w-full lg:mb-0 lg:w-8/12 xl:w-8/12 xxl:w-1/2 lg:leading-snug jobs__title__initial--text " + textTitleColorClass, ref: nativeLeftTitleRef }, { children: mainTitleText }), void 0) }), void 0));
};
export default InitialTitle;
